import Modal from 'antd/es/modal';
import Form from 'antd/es/form';
import Input from 'antd/es/input';
import Popconfirm from 'antd/es/popconfirm';
import Button from 'antd/es/button';
import Select from 'antd/es/select';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { useCallback, useMemo } from 'react';
import {
  $adminCreateUserModal,
  createUserByAdminFx,
  setAdminCreateUserModalEv,
  submitAdminCreateUserEv,
} from '../../../models/adminSecurityModel/index.js';
import {
  $regionsSelect,
  $userRolesSelect,
} from '../../../models/globalModel/index.js';

export default function AdminCreateUserModal({ isAdmin, isSuperAdmin }) {
  const { t } = useTranslation();
  const [userForm] = Form.useForm();
  const loading = useUnit(createUserByAdminFx.pending);
  const modal = useUnit($adminCreateUserModal);
  const setModal = useUnit(setAdminCreateUserModalEv);

  const createAllowed = !!(isAdmin || isSuperAdmin);

  const roles = useUnit($userRolesSelect);
  const rolesSelect = useMemo(() => {
    if (!isSuperAdmin) {
      const rmIdx = roles.findIndex((i) => i?.value === 'admin');
      return roles?.toSpliced(rmIdx, 1);
    } else {
      return roles;
    }
  }, [isSuperAdmin, roles]);

  const regionsSelect = useUnit($regionsSelect);
  const selectedRole = Form.useWatch('role', userForm);
  const regionRequired = ['chamber', 'mio', 'rpp_bc'].includes(selectedRole);

  const submit = useUnit(submitAdminCreateUserEv);

  const validPass =
    /^(?=.*[a-zA-Z0-9_!@#$%^&?*])(?=.*[A-Z])(?=.*[0-9])(?=.*[_!@#$%^&?*])[a-zA-Z0-9_!@#$%^&?*]{8,32}$/;

  const onCancel = useCallback(() => {
    userForm.resetFields();
    setModal(false);
  }, [setModal, userForm]);

  return (
    <Modal
      title={t('Создать пользователя')}
      open={modal}
      footer={null}
      onCancel={onCancel}
    >
      <Form
        form={userForm}
        layout="vertical"
        validateTrigger={'onBlur'}
        onFinish={(values) => submit(values)}
      >
        <Form.Item
          name="username"
          label={t('Логин')}
          rules={[{ required: true, message: t('Обязательное поле') }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="password"
          label={t('Пароль')}
          rules={[
            { required: true, message: t('Обязательное поле') },
            {
              pattern: validPass,
              message: t(
                'Пароль должен содержать символы a-z, A-Z, 0-9, _!@#$%^&?*, длина 8-32'
              ),
            },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="role"
          label={t('Роль')}
          rules={[{ required: true, message: t('Обязательное поле') }]}
        >
          <Select
            options={rolesSelect}
            onSelect={() => userForm.resetFields(['region_id'])}
          />
        </Form.Item>
        {regionRequired && (
          <Form.Item
            name="region_id"
            label={t('Регион')}
            rules={[{ required: true, message: t('Обязательное поле') }]}
          >
            <Select options={regionsSelect} />
          </Form.Item>
        )}
        <Form.Item
          name="gov_id"
          label={t('БИН/ИИН')}
          // rules={[{ required: true, message: t('Обязательное поле') }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="email"
          label={t('Email')}
          // rules={[{ required: true, message: t('Обязательное поле') }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="work_phone"
          label={t('Телефон')}
          // rules={[{ required: true, message: t('Обязательное поле') }]}
        >
          <Input />
        </Form.Item>
      </Form>
      <Popconfirm
        title={t('Вы уверены, что все данные верны?')}
        disabled={!createAllowed}
        onConfirm={() => userForm.submit()}
      >
        <Button type="primary" loading={loading} disabled={!createAllowed}>
          {t('Подтвердить')}
        </Button>
      </Popconfirm>
    </Modal>
  );
}
